import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

import NavigationBarMerchant from "../components/navigation-bar-merchant";
import FAQMerchant from "../components/faq-merchant";
import ContactFormDark from "../components/contact-form-dark";
import Footer from "../components/footer";
import "./merchant.css";

const Merchant = (props) => {
  return (
    <div className="merchant-container1">
      <Helmet>
        <title>
          Merchant | CashOver Pay | Accept Payments, Create Menus & Manage Your
          Business
        </title>
        <meta
          name="description"
          content="Join CashOver as a merchant and seamlessly accept payments, create free menus, manage transactions and orders, and grow your business with our secure and easy-to-use digital wallet platform."
        />
        <meta
          property="og:title"
          content="Merchant | CashOver | Accept Payments, Create Menus & Manage Your Business"
        />
        <meta
          property="og:description"
          content="Join CashOver as a merchant and seamlessly accept payments, create free menus, manage transactions and orders, and grow your business with our secure and easy-to-use digital wallet platform."
        />
        <meta
          property="og:image"
          content="https://cashover.money/merchant%20hero.webp"
        />
      </Helmet>

      <NavigationBarMerchant
        text={
          <Fragment>
            <span className="merchant-text10">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="merchant-text11">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-merchantroot-class-name"
      ></NavigationBarMerchant>
      <header className="merchant-column1">
        <div className="merchant-dummy"></div>
        <img
          alt="image"
          src="/merchant%20hero.webp"
          className="merchant-image10"
        />
        <div className="merchant-row1">
          <div className="merchant-column2">
            <h1 className="merchant-title">
              <span>
                GO DIGITAL -
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="merchant-text13">GROW</span>
              <span> YOUR BUSINESS WITH CASHOVER!</span>
            </h1>
            <h2 className="merchant-subtitle">
              Receive payments instantly, get a free store menu, and manage
              employees, all at almost no expense or hidden fees. Available all
              over Lebanon!
            </h2>
            <div className="merchant-stores">
              <a
                href={process.env.REACT_APP_MERCHANT_ANDROID_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-link1"
              >
                <img
                  alt="image"
                  src="/play-badge.webp"
                  className="merchant-image11"
                />
              </a>
              <a
                href={process.env.REACT_APP_MERCHANT_IOS_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-link2"
              >
                <img
                  alt="image"
                  src="/apple-badge.webp"
                  className="merchant-image12"
                />
              </a>
            </div>
          </div>
          <img
            alt="image"
            src="/merchant%20hero.webp"
            className="merchant-phone-image"
          />
        </div>
        <div className="merchant-row2">
          <svg viewBox="0 0 1024 1024" className="merchant-icon1">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
          <span className="merchant-text15">Scroll Down to Learn More</span>
          <svg viewBox="0 0 1024 1024" className="merchant-icon3">
            <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
          </svg>
        </div>
      </header>
      <div className="merchant-column3">
        <h2 className="merchant-text16">Thousands of stores Use Cashover</h2>
        <h2 className="merchant-text17">to</h2>
        <div className="merchant-row3">
          <div className="merchant-box1">
            <h2 className="merchant-text18">GET PAID</h2>
            <img
              alt="image"
              src="/get%20paid.webp"
              className="merchant-image13"
            />
            <span className="merchant-text19">
              Use your merchant account to receive payments from customers
              buying your products or services online.
            </span>
          </div>
          <div className="merchant-box2">
            <h2 className="merchant-text20">analyze</h2>
            <img alt="image" src="/analyze.webp" className="merchant-image14" />
            <span className="merchant-text21">
              Use your merchant account to receive payments from customers
              buying your products or services online.
            </span>
          </div>
          <div className="merchant-box3">
            <h2 className="merchant-text22">Modernize</h2>
            <img alt="image" src="/request.webp" className="merchant-image15" />
            <span className="merchant-text23">
              Use your merchant account to receive payments from customers
              buying your products or services online.
            </span>
          </div>
        </div>
        <span className="merchant-text24">
          Pay And Get Paid  Across Lebanon
        </span>
        <div className="merchant-row4">
          <div className="merchant-box4">
            <span className="merchant-text25">Currencies</span>
            <span className="merchant-text26">Trade in LBP and USD</span>
          </div>
          <div className="merchant-box5">
            <span className="merchant-text27">Free menu</span>
            <span className="merchant-text28">
              Create your store menu and edit it anytime. Always for Free!
            </span>
          </div>
          <div className="merchant-box6">
            <span className="merchant-text29">Secure revenue</span>
            <span className="merchant-text30">
              Prevent money theft by going digital.
            </span>
          </div>

          <div className="merchant-box7">
            <span className="merchant-text31">Ultra Low fees</span>
            <span className="merchant-text32">
              <span>
                Fees on CashOver are super low.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <a
                href={process.env.REACT_APP_FEES_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-text34"
              >
                Learn more.
              </a>
            </span>
          </div>
        </div>
      </div>
      <div className="merchant-column4">
        <div className="merchant-menu1">
          <img alt="image" src="/menu.webp" className="merchant-image16" />
          <div className="merchant-container2">
            <span className="merchant-text35">Create Your Own Menu</span>
            <span className="merchant-text36">
              <span>
                Manage and edit your menu inside CashOver Merchant app or
                website, anytime and anywhere.
              </span>
              <br></br>
              <br></br>
              <span>
                Be it a restaurant or a store or even a service, add your dishes
                or products for everyone to view.
              </span>
              <br></br>
              <br></br>
              <span>
                Customers can visit your menu using a QR-Code or placing orders
                on
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <a
                href={process.env.REACT_APP_DROPOVER_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-link3"
              >
                DROPOVER
              </a>
              <span> (our food and retail ordering app).</span>
              <br></br>
              <br></br>
              <span>
                No need to pay anything, it is totally free. Get a beautiful
                Menu and Ordering system  Now!
              </span>
              <br></br>
            </span>
            <div className="merchant-row5">
              <a
                href={process.env.REACT_APP_MERCHANT_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-action11 thq-button-filled-dark"
              >
                Create Free Menu
              </a>
              <a
                href={process.env.REACT_APP_DROPOVER_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-action12 thq-button-outline-dark"
              >
                Visit DropOver
              </a>
            </div>
          </div>
        </div>
        <div className="merchant-menu2">
          <div className="merchant-container3">
            <span className="merchant-text49">Get Paid Instantly</span>
            <span className="merchant-text50">
              <span>
                With CashOver, people can pay you on the spot in multiple
                currencies
              </span>
              <br></br>
              <br></br>
              <span>
                Modernize your store and follow the latest trends to attract
                more customers.
              </span>
              <br></br>
              <br></br>
              <span>
                You can also
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <Link to="/cash-over-sdk" className="merchant-navlink2">
                add CashOver
              </Link>
              <span>
                {" "}
                to your website or app, no more high transfer fees from banks
                and difficult cash-out procedures. Learn more about fees 
              </span>
              <a
                href={process.env.REACT_APP_FEES_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="merchant-link4"
              >
                here
              </a>
              <span className="merchant-text59">.</span>
              <br></br>
              <br></br>
              <span>
                Thousands of stores are already using CashOver. Join them now.
              </span>
              <br></br>
            </span>
            <a
              href={process.env.REACT_APP_MERCHANT_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="merchant-action13 thq-button-filled-dark"
            >
              Create account in 60 seconds
            </a>
          </div>
          <img
            alt="image"
            src="https://images.unsplash.com/photo-1600147131759-880e94a6185f?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDJ8fHFyJTIwY29kZXxlbnwwfHx8fDE3MTYwNjAxNTZ8MA&amp;ixlib=rb-4.0.3&amp;w=1000"
            className="merchant-image17"
          />
        </div>
        <div className="merchant-menu3">
          <img
            alt="image"
            src="https://images.unsplash.com/photo-1588675646184-f5b0b0b0b2de?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fHdhaXRlcnxlbnwwfHx8fDE3MTYwNzc5MzZ8MA&amp;ixlib=rb-4.0.3&amp;w=1000"
            className="merchant-image18"
          />
          <div className="merchant-container4">
            <span className="merchant-text64">
              Manage Employees &amp; Permissions
            </span>
            <span className="merchant-text65">
              <span>
                What if you want to have your cashier or worker receive money in
                your absence.
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                Do not worry, CashOver allows to add employees on your merchant
                account to receive or refund money on your behalf.
              </span>
              <br></br>
              <br></br>
              <span>
                You can add them and remove them whenever you want. You are the
                owner and boss.
              </span>
              <br></br>
              <br></br>
            </span>
            <button className="merchant-action14 thq-button-filled-dark">
              <a
                href={process.env.REACT_APP_MERCHANT_URL}
                target="_blank"
                rel="noreferrer noopener"
              >
                Get Started
              </a>
            </button>
          </div>
        </div>
        <div className="merchant-menu4">
          <div className="merchant-container5">
            <span className="merchant-text75">Online Store? No Problem</span>
            <span className="merchant-text76">
              <span>
                As a CashOver Merchant, you have free access to use our SDK and
                implement CashOver payment method directly into your site or
                mobile app.
              </span>
              <br></br>
              <br></br>
              <span>
                No longer slow bank transfers, endless fees and hard bank
                approvals. CashOver is the right solution for your online
                business.
              </span>
              <br></br>
              <br></br>
              <span>Receive money like you receive text messages!</span>
              <br></br>
            </span>
            <a
              href={process.env.REACT_APP_DOCS_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="merchant-action15 thq-button-filled-dark"
            >
              View Documentation
            </a>
          </div>
          <img
            src="https://images.unsplash.com/photo-1664455340023-214c33a9d0bd?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDcyfHxjYXJ0JTIwb25saW5lfGVufDB8fHx8MTcxNjA4NjM1OHww&amp;ixlib=rb-4.0.3&amp;w=1000"
            className="merchant-image19"
          />
        </div>
      </div>
      <FAQMerchant rootClassName="faq-merchantroot-class-name"></FAQMerchant>
      <ContactFormDark rootClassName="contact-form-darkroot-class-name1"></ContactFormDark>
      <Footer rootClassName="footerroot-class-name6"></Footer>
    </div>
  );
};

export default Merchant;
